import {OrderLastType} from 'desktop/pages/success/types/types';

/**
 * Adapter for review popups data
 */
export function orderLastAdapter(orderLast: OrderLastType) {
    const orderLastData = {
        ...orderLast,
        items: orderLast.items.map(item => ({
            ...item,
            product: {
                finalPrice: parseFloat(item.price),
                urlPath: item.productUrl,
            },
        })),
        shipping_address: {
            email: orderLast.email,
            firstname: orderLast.firstName,
            lastname: orderLast.lastName,
        },
    };

    return orderLastData;
}
